import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/illustrations/bookings-card.svg")